import { VegaLiteSpec, VegaSpec } from "./types.js";

export const isVegaLiteSpec = (
  spec: VegaLiteSpec | VegaSpec,
): spec is VegaLiteSpec =>
  // Assume if schema is null that it's a Vega-Lite spec and not Vega
  spec.$schema == null || spec.$schema.includes("/vega-lite/");

export const isVegaSpec = (spec: VegaLiteSpec | VegaSpec): spec is VegaSpec =>
  spec.$schema != null && spec.$schema.includes("/vega/");

const isLegacySchemaLabel = (spec: VegaLiteSpec): boolean => {
  const url = spec.$schema;
  if (url == null) return true;
  return url.endsWith("v4.json") || url.endsWith("v5.json");
};

// Before we upgraded to Vega-Lite 6 we generated v4 or v5 schema labels (or no
// label at all) and saved them in the DB for VegaChartCells. Those specs are
// structurally compatible with v6 — we never let people use v4-only or v5-only
// features in the limited UI we provided then, and the v6 compile path was
// validated against the entire prod vegaSpec corpus with 0 regressions — so
// normalize them on read by overwriting the `$schema` declaration. This also
// silences vega-embed v7's warning when a v5-labeled (or unlabeled) spec is
// rendered against the v6 schema.
export const upgradeVegaLiteSpecIfNecessary = (
  spec: VegaLiteSpec,
): VegaLiteSpec => {
  return isLegacySchemaLabel(spec)
    ? {
        ...spec,
        $schema: "https://vega.github.io/schema/vega-lite/v6.json",
      }
    : spec;
};
